<div class="container pb-13">
  <lib-web-shared-ui-page-header [data]="pageHeaderObj()" (emitPathUrl)="redirectTo($event)"></lib-web-shared-ui-page-header>
  <p>นโยบายการรับประกันคุณภาพฯ สำหรับผลิตภัณฑ์ยางรถยนต์ Advance-PCR มีเงื่อนไขและข้อปฏิบัติดังนี้</p>
  <lib-web-shared-ui-warranty-policy [data]="warrantyPolicyObj"></lib-web-shared-ui-warranty-policy>
</div>
